<script setup lang="ts">
  import Typography from '@/components/common/Typography.vue'
  import AppLayout from '@/components/layout/AppLayout.vue'
  import StandardLayout from '@/components/layout/Layout.vue'
  import { useI18n } from 'vue-i18n'

  const { t } = useI18n()
</script>

<template>
  <StandardLayout>
    <AppLayout>
      <div class="content-rights">
        <Typography
          variant="h2"
          component="h1"
        >
          {{ t('contentRightsPage.title') }}
        </Typography>

        <Typography variant="h4">
          {{ t('contentRightsPage.attentionHeader') }}
        </Typography>

        <Typography variant="preamble">
          {{ t('contentRightsPage.contentOwnership') }}
        </Typography>
        <Typography variant="preamble">
          {{ t('contentRightsPage.usageRestrictions') }}
        </Typography>
        <Typography variant="preamble">
          {{ t('contentRightsPage.userResponsibility') }}
        </Typography>
      </div>
    </AppLayout>
  </StandardLayout>
</template>

<style scoped lang="scss">
  .content-rights {
    padding-top: 50px;
    max-width: 800px;
    margin: 0 auto;
  }
</style>
